import { useEffect, useRef, useState } from "react";
import api from "./api";

// State the API keeps for the signed-in user (saved views, column layout):
// loaded when the user changes, written back whole whenever it changes.
// Nothing is sent until the load has come back, so a slow load can never
// overwrite what the server has with the defaults. If the server cannot be
// reached the state still works, it is just not remembered.
export function useServerState(path, userKey, fallback, fromServer) {
  const [value, setValue] = useState(fallback);
  const saved = useRef(null); // what the server has, as JSON

  useEffect(() => {
    let live = true;
    saved.current = null;
    api
      .get(path)
      .then((res) => {
        if (!live) return;
        const loaded = fromServer(res.data);
        saved.current = JSON.stringify(loaded);
        setValue(loaded);
      })
      .catch(() => {});
    return () => {
      live = false;
    };
  }, [path, userKey, fromServer]);

  useEffect(() => {
    if (saved.current === null) return;
    const json = JSON.stringify(value);
    if (json === saved.current) return;
    saved.current = json;
    api.put(path, value).catch(() => {});
  }, [path, value]);

  return [value, setValue];
}
